import angular from 'angular';
import ngRedux from 'ng-redux';
import 'angular-gettext';

import appStateModule from '../../state/state.module';

import {
	tableColumnSelectorComponent,
	TableColumnSelectorController
} from './table-column-selector.component';

/** Asset List page module */
export default angular
	.module('components.table-column-selector', [
		appStateModule,
		ngRedux,
		'gettext'
	])
	// Asset List body
	.component('tableColumnSelector', tableColumnSelectorComponent)
	.controller('TableColumnSelectorController', TableColumnSelectorController)
	.name;
